module.exports = __webpack_public_path__ + "static/fonts/SFProDisplay-Bold.0ee6951.eot";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/SFProDisplay-Bold/SFProDisplay-Bold.eot
// module id = pjn4
// module chunks = 24